/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { task } from 'ember-concurrency';

import TemplateModel from 'cio/models/template';

interface CioTemplateCardArgs {
  allocation: number;
  index: number;
  isRecentlyAdded: boolean;
  splitTestActive: boolean;
  showIcon: boolean;
  template: TemplateModel;
  languageVariations?: TemplateModel[];
  onDeleteTemplate: () => unknown;
  hasReadOnlyPermission: boolean;
}

export default class CioTemplateCard extends Component<CioTemplateCardArgs> {
  @tracked _isEditing = true;

  get isEditing() {
    return this.args.isRecentlyAdded && this._isEditing;
  }

  get showIcon() {
    return this.args.showIcon ?? true;
  }

  get translations() {
    return this.args.languageVariations?.filterBy('testGroupId', this.args.template.testGroupId);
  }

  saveTemplate = task({ drop: true }, async () => {
    await this.args.template.save();
    this._isEditing = false;
  });
}
